import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import LottiePlayer from "../components/lottiePlayer/LottiePlayer";

const KontentItemLottieSetup = ({
  data,
  className = undefined,
  renderAsOverlay = false,
}) => {
  const lottieSetup = data.value ? data.value[0] : data;

  if (!lottieSetup || !lottieSetup.elements) {
    return null;
  }
  const loop = lottieSetup.elements.player_options.value.some((option) => option.codename.toLowerCase() === "loop");

  const hover = lottieSetup.elements.player_options.value.some((option) => option.codename.toLowerCase() === "hover");

  return (
    <LottiePlayer
      path={lottieSetup.elements.lottie_json.value[0].url}
      renderAsOverlay={renderAsOverlay}
      autoplay={!hover}
      loop={loop}
      className={className}
    />
  );
};

export const query = graphql`
  fragment KontentItemLottieSetup on kontent_item_lottie_setup {
    id
    elements {
      player_options {
        value {
          codename
        }
      }
      lottie_json {
        value {
          url
        }
      }
    }
  }
`;

KontentItemLottieSetup.propTypes = {
  className: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  renderAsOverlay: PropTypes.bool,
};

export default KontentItemLottieSetup;
